exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".variations-toggle[data-v-32918e75]{cursor:pointer}.variation-separator[data-v-32918e75]{margin:0 4px;color:#c0c4cc}.variation-codes[data-v-32918e75]{color:#909399}.variation-name .variation-codes[data-v-32918e75]{display:block;padding-left:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32918e75","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./modules/Inventory/Resources/assets/js/inventory/index.vue
// module id = /iVO
// module chunks = 0